import { useEffect, useState } from "react";
import MySelect from "../UI/select/MySelect";
import MyButton from "../UI/button/MyButton";
import { useAxiosPatchRefreshing, useAxiosPostRefreshing, useAxiosPutRefreshing } from "../../hooks/useAxios";
import { backend_routes } from "../../common/links";
import MyInput from "../UI/input/MyInput";

const LegendsModal = function ({ legendsMap, legendSetCallback, closeModalCallback }) {
    const legends = [];
    legends.push({ value: "addLegend", name: "Добавить новую" });
    for (let mapItem of legendsMap.keys()) {
        legends.push({ value: mapItem, name: legendsMap.get(mapItem) });
    }
    const [putLegend, isPatchLoading] = useAxiosPutRefreshing(
        function (response) {
            if (response.status === 200) {
                let legendsNew = legendsMap;
                legendsNew.set(request.code, request.content);
                legendSetCallback(legendsNew);
                closeModalCallback(false);
            }
        });

    const [postLegend, isPostLoading] = useAxiosPostRefreshing(
        function (response) {
            if (response.status === 200) {
                let legendsNew = legendsMap;
                legendsNew.set(request.code, request.content);
                legendSetCallback(legendsNew);
                closeModalCallback(false);
            }
        });
    const send = function () {
        if (code === "addLegend") postLegend(backend_routes.LEGENDS_POST, request);
        else putLegend(backend_routes.LEGENDS_UPDATING, request);
    }

    const [request, setRequest] = useState({});
    const [code, setCode] = useState("addLegend");
    const [newLegendCode, setNewLegendCode] = useState("");
    const [newLegendName, setNewLegendName] = useState("");

    useEffect(() => {
        if (code !== "addLegend") {
            setNewLegendCode(code);
            // setNewLegendName(legends.filter(item => item.value === code)[0].name);
        }
        setRequest(
            {
                code: newLegendCode,
                content: newLegendName
            }
        );
    }
        , [code, newLegendCode, newLegendName]);

    return (
        <>  
            <MyInput disabled={code !== "addLegend"} style={{ marginRight: "5px", marginBottom: "5px"}} type="text" placeholder='Код латиницей' value={newLegendCode} onChange={event => setNewLegendCode(event.target.value)} />
            <br />
            <MyInput style={{ marginRight: "5px", marginBottom: "5px" }} type="text" placeholder='Название легенды' value={newLegendName} onChange={event => setNewLegendName(event.target.value)} />
            <br/>
            <MySelect style={{ width: "100%" }} options={legends} defaultValue={"Тип события"} value={code} onChange={setCode} />
            <br />
            <MyButton style={{ width: "100%", marginTop: "5px" }} onClick={send}>
                {
                    code==="addLegend"
                    ? <>Добавить</>
                    : <>Изменить</>
                }
            </MyButton>
            {/* <MyButton onClick={() => { putEvent(backend_routes.EVENTS_UPDATING, request) }}>Сохранить</MyButton> */}
        </>
    );
}
export default LegendsModal;